import { Routes } from '@angular/router';
import { LayoutComponent } from './shared/layout/layout.component';
import { authGuard, noAuthGuard } from './auth/auth.guard';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'auth/login',
        pathMatch: 'full'
    },
    {
        path:'auth',
        loadChildren: () => import('./auth/auth.route').then(m => m.routes),
        canActivate:[noAuthGuard]
    },
    {
        path:'',
        component: LayoutComponent,
        children: [
            {
                path: 'dashboard',
                loadComponent: () => import('./components/dashboard/dashboard.component').then(c => c.DashboardComponent)
            },
            {
                path: 'page-management',
                loadComponent: () => import('./components/page-management/page-management.component').then(c => c.PageManagementComponent)
            },
            {
                path: 'stack/add',
                loadComponent: () => import('./components/add-stack/add-stack.component').then(c => c.AddStackComponent)
            },
            {
                path: 'stack/edit/:id',
                loadComponent: () => import('./components/add-stack/add-stack.component').then(c => c.AddStackComponent)
            }
        ],
        canActivate:[authGuard]
    }
];
